import { Avatar, Box, Checkbox, Divider, Flex, Grid, Group, Input, Text } from "@mantine/core";
import { useDebouncedValue } from "@mantine/hooks";
import { IconPhoto } from "@tabler/icons-react";
import React from "react";
import { bankAccountApi } from "../../apis";
import { IBankAccount } from "../../interfaces/IBankAccount";
import { ColumnType, Table } from "../table";
import RenderText from "../ui/render-text";

export function PartnerManagementBankAccountList() {
  const [regNumber, setRegNumber] = React.useState("");
  const [debouncedRegNumber] = useDebouncedValue(regNumber, 600);

  const columns = useHeader({
    onClick: (key, item) => {
      switch (key) {
        case "detail": {
          break;
        }
      }
    },
  });

  return (
    <Box>
      <Grid mb="xs">
        <Grid.Col span={{ xs: 12, sm: 6, md: 6, lg: 3 }}>
          <Input
            value={regNumber}
            leftSectionWidth={80}
            placeholder="хайх"
            style={{ borderRight: "none", borderRadius: "4px 0 0 4px" }}
            leftSection={
              <Group w={"calc(100% - 20px)"} align="center">
                <Text size="sm" fw={450} c="#44566C">
                  {"ТТД"}
                </Text>
                <Text>:</Text>
              </Group>
            }
            onChange={(e) => {
              setRegNumber(e?.currentTarget?.value);
            }}
            minLength={7}
            maxLength={7}
          />
        </Grid.Col>
      </Grid>
      <Divider color="gray" my={20} />
      <Table
        name="partner-management-bank-account.list"
        columns={columns}
        filters={{ regNumber: debouncedRegNumber, businessId: "", partnerId: "" }}
        loadData={(data) => bankAccountApi.list(data!)}
      />
    </Box>
  );
}

const useHeader = ({ onClick }: { onClick: (key: string, record: IBankAccount) => void }): ColumnType<IBankAccount>[] => [
  {
    title: "#",
    width: "30px",
    render: (_r, index) => <RenderText text={index + 1} />,
  },
  {
    title: "Зураг",
    dataIndex: "icon",
    render: (record) => {
      return (
        <Avatar src={`${record.icon}`} alt="">
          <IconPhoto />
        </Avatar>
      );
    },
  },
  {
    title: "Регистр",
    sorter: true,
    dataIndex: "regNumber",
    render: (record) => <RenderText text={record?.business?.regNumber || "-"} />,
  },
  {
    title: "Партнер нэр",
    sorter: true,
    dataIndex: "businessName",
    render: (record) => {
      return (
        <Box>
          <RenderText text={record?.business?.partner?.businessName || "-"} />
          <RenderText text={record?.business?.partner?.refCode || "-"} />
        </Box>
      );
    },
  },
  {
    title: "Бизнес нэр",
    sorter: true,
    dataIndex: "profileName",
    render: (record) => {
      return (
        <Box>
          <RenderText text={record?.business?.profileName || "-"} color="#141517" />
          <RenderText text={record?.business?.refCode || "-"} />
        </Box>
      );
    },
  },
  {
    title: "Банкны нэр",
    sorter: true,
    dataIndex: "bankName",
    render: (record) => <RenderText text={record?.bankName || "-"} />,
  },
  {
    title: "Дансны дугаар",
    sorter: true,
    dataIndex: "number",
    render: (record) => <RenderText text={record?.number || "-"} />,
  },
  {
    title: "Валют",
    sorter: true,
    dataIndex: "businessName",
    render: (record) => <RenderText text={record.currency || "-"} />,
  },
  {
    title: "Үндсэн эсэх",
    sorter: true,
    dataIndex: "shortName",
    render: (record) => (
      <Flex gap="xs" align="center">
        <Checkbox checked={record.isDefault} onChange={() => {}} />
        <RenderText text={record.isDefault ? "Тийм" : "Үгүй"} />
      </Flex>
    ),
  },
  {
    title: "Товч нэр",
    sorter: true,
    dataIndex: "shortName",
    render: (record) => <RenderText text={record.shortName || "-"} />,
  },
];
